<template>
  <div
    v-if="canChangeRelease && releaseStatusLabel === 'Offen'"
    class="flex flex-col gap-5 pt-2.5"
  >
    <div class="flex w-full rounded-md bg-subtle p-4">
      <IconWrapper icon="info" class="mr-2" />
      <p class="body-1 leading-6">Es liegt keine Freigabeaufforderung vor</p>
    </div>
  </div>
  <div
    v-if="releaseStatusLabel !== 'Offen'"
    :class="`flex flex-col gap-5 ${statusDisplay.containerClasses}`"
  >
    <div
      :class="`flex w-full rounded-md p-4 ${statusDisplay.infoBoxBackground}`"
    >
      <IconWrapper
        :icon="statusDisplay.icon"
        class="mr-2"
        :fill="statusDisplay.color"
      />
      <p :class="`body-1 leading-6 ${statusDisplay.color}`">
        {{ statusDisplay.decisionText }}
      </p>
    </div>

    <div
      v-if="canChangeRelease || releaseStatusLabel === 'Angefordert'"
      :class="`grid grid-cols-2 items-start gap-5 pt-2.5`"
    >
      <h5 class="text-title-neutral">Freigabe angefordert durch</h5>
      <span class="body-1 leading-4 text-neutral">{{
        projectData.release_requested_by
      }}</span>
      <h5 class="text-title-neutral">Freigabe angefordert am</h5>
      <span class="body-1 leading-4 text-neutral">{{
        projectData.release_requested_at
      }}</span>
    </div>

    <div
      v-if="
        releaseStatusLabel === 'Genehmigt' || releaseStatusLabel === 'Abgelehnt'
      "
      class="grid grid-cols-2 items-start gap-5 pt-2.5"
    >
      <h5 class="text-title-neutral">
        Freigabe {{ statusDisplay.decisionVerb }} durch
      </h5>
      <span class="body-1 leading-4 text-neutral">{{
        projectData.release_status_changed_by
      }}</span>
      <h5 class="text-title-neutral">
        Freigabe {{ statusDisplay.decisionVerb }} am
      </h5>
      <span class="body-1 leading-4 text-neutral">{{
        projectData.release_status_changed_at
      }}</span>
      <h5 class="text-title-neutral">Kommentar</h5>
      <span class="body-1 leading-4 text-neutral">{{
        projectData.release_comment
      }}</span>
    </div>

    <div
      v-if="releaseStatusLabel === 'Genehmigt'"
      class="flex justify-end gap-2.5 py-2.5"
    >
      <ButtonEl icon="map" icon-type="round" @click="goToMap" />
    </div>
  </div>
  <div class="mt-5 rounded-md bg-subtle p-[10px]">
    <WiReDownloadContainer
      :wire-id="projectData.id"
      :wire-name="projectData.name"
    />
  </div>
</template>
<script setup>
import IconWrapper from '@/components/storybook/src/stories/IconWrapper/IconWrapper.vue';
import ButtonEl from '@/components/storybook/src/stories/button/ButtonEl.vue';
import { computed } from 'vue';
import { statusMapping } from '@/apps/economic-efficiency/status-data';
import { downloadFile } from '@/utils/axiosHelper';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import WiReDownloadContainer from '@/apps/economic-efficiency/WiReDownloadContainer.vue';

const props = defineProps({
  projectData: {
    type: Object,
  },
  releaseStatusLabel: {
    type: String,
  },
  canChangeRelease: {
    type: Boolean,
  },
});

const store = useStore();
const router = useRouter();

const statusDisplay = computed(
  () => statusMapping[props.projectData.release_status].display,
);

function goToMap() {
  localStorage.setItem('denominator', 'scenario');
  localStorage.setItem('municipality', 'all');
  localStorage.setItem('scenario', props.projectData.scenario_id);
  store.commit('heatProject/SET_LOAD_PROJECTS_ON_MAPLOAD', [
    props.projectData.heat_project,
  ]);
  router.push(`/map/${props.projectData.scenario_id}`);
}

function downloadExcel() {
  const url = `/api/heatprojects/wi-re/wi-re/${props.projectData.id}/download-excel/`;
  downloadFile(url);
}
</script>
